import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f53b793"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "intro" }
const _hoisted_2 = { class: "text-center mb-[42px]" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["innerHTML"]

import { withDefaults } from 'vue';
import { IItem } from '@/interface/article.d';
interface IProps {
    dataList: Array<Partial<IItem>>;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyIntro',
  props: {
    dataList: { default: () => [{}] }
  },
  setup(__props: any) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "w-[600px] h-[400px] inline-block",
        src: _ctx.dataList[0]?.banner,
        alt: "",
        srcset: ""
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("p", {
      innerHTML: _ctx.dataList[0]?.content,
      class: "indent-[2em]"
    }, null, 8, _hoisted_4)
  ]))
}
}

})